export enum CouponType {
  mass = 'mass',
  targeted = 'targeted',
}
